<template>
    <div class="card-product-last-info">
        <div class="content">
            <h4 class="title">¿No encuentras lo que buscas?</h4>
            <h4 class="title_alt">Podemos ayudarte</h4>
            <p>Rellena el siguiente formulario y en breve te daremos una respuesta.</p>
            <load-spiner v-if="loading"></load-spiner>
            <form v-else>
                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <div class="content-input">
                                <input :id="'nombre_'+week" type="text" :class="'form-element '+((errors['nombre']) ? 'is-invalid' : '')" v-model="form.nombre" placeholder="Nombre">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <div class="content-input">
                                <input :id="'movil_'+week" type="text" :class="'form-element '+((errors['movil']) ? 'is-invalid' : '')" v-model="form.movil" placeholder="Móvil (opcional)">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <div class="content-input">
                                <input :id="'email_'+week" type="text" :class="'form-element '+((errors['email']) ? 'is-invalid' : '')" v-model="form.email" placeholder="Correo electrónico">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <div class="content-input">
                                <textarea :id="'mensaje_'+week" :class="'form-element '+((errors['mensaje']) ? 'is-invalid' : '')" v-model="form.mensaje" placeholder="¿Qué necesitas?"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bp-form-group">
                    <button class="alter-btn-green" type="submit" @click="submit()" data-testid="login_button">
                        <span>Enviar</span>
                    </button>
                </div>
            </form>
            <p>Al envíar el formulario, aceptas los <a href="/terminos-condiciones">términos y condiciones</a> y la <a href="/politica-privacidad">política de privacidad</a></p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['week'],
        data() {
            return {
                form: {
                    nombre: "",
                    movil: "",
                    semana: "",
                    type: "",
                    email: "",
                    mensaje: ""
                },

                errors: [],
                loading: false,
            }
        },
        mounted() {
            this.form.semana = this.week;
        },
        methods: {
            submit: function () {
                this.loading = true;

                this.form['type'] = 'contact_in_week';

                axios.post(this.route('send.contact'), this.form).then(response => {
                    this.loading = false;
                    this.errors = [];

                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });

                    this.form = {nombre: "", semana: "", movil: "", mensaje: "", type: "", email: ""};
                }).catch(e => {
                    this.loading = false;
                    this.errors = e.response.data.errors;

                    Vue.toasted.show(e.response.data.info ? e.response.data.info : 'Ha habido un error', {
                        type: "error",
                        duration: 3000
                    });
                });
            }
        }
    }
</script>
